<template>
    <div v-if="isActive">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'tab-content',
    props: {
        selected: {
            default: false,
        },
        title: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isActive: false,
        }
    },
    created() {
        this.isActive = this.selected
    }
}
</script>